import callAPiBase from './base';

const schedulesMatrixApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/scheduleMatrixList',
      method: 'GET',
      useToken: true,
      title: 'Schedule Matrix - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/scheduleMatrixCreate',
      method: 'POST',
      useToken: true,
      title: 'Schedule Matrix - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/scheduleMatrixUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Schedule Matrix - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/scheduleMatrixDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Schedule Matrix - Delete',
      params,
    }),
  getConfig: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/scheduleMatrixConfigList',
      method: 'GET',
      useToken: true,
      title: 'Schedule Matrix Config - Get List',
      params,
    }),

  createConfig: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/scheduleMatrixConfigsCreate',
      method: 'POST',
      useToken: true,
      title: 'Schedule Matrix Config - Create',
      data,
    }),
  updateConfig: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/scheduleMatrixConfigsUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Schedule Matrix Config - Update',
      data,
    }),
  deleteConfig: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/scheduleMatrixConfigsDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Schedule Matrix Config - Delete',
      params,
    }),
  getTripSchedules: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/tripScheduleList',
      method: 'GET',
      useToken: true,
      title: 'Trip Schedule - Get List',
      params,
    }),
  updateTripSchedules: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripScheduleListUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Trip Schedule - Update',
      data,
    }),
  createTripSchedules: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripScheduleCreate',
      method: 'POST',
      useToken: true,
      title: 'Trip Schedule - Create',
      data,
    }),
  deleteListTripSchedules: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripScheduleListDelete',
      method: 'POST',
      useToken: true,
      title: 'Trip Schedule - Delete',
      data,
    }),
  tripScheduleInfo: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripScheduleUpdateInfo ',
      method: 'PUT',
      useToken: true,
      title: 'Trip Schedule - Info',
      data,
    }),
  tripScheduleeReservations: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripScheduleUpdateReservation',
      method: 'PUT',
      useToken: true,
      title: 'Trip Schedule - Reservations',
      data,
    }),
};

export { schedulesMatrixApi };
export default schedulesMatrixApi;
